export const mutations = {
  addExpenseItems(state) {
    state.expense_item.push({
      expense_description: "",
      expense_measurement: "",
      qty: "",
      unit_price: "",
      total_price: "",
     
    });
  },

  STORE_EXPENSES(state, expenses) {
    state.expenses = expenses;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/expenses/mutations.js